import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../variables/api";
import { Route, Routes, useNavigate } from "react-router-dom";
import { createBrowserHistory } from "history";

import "./Table.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
const Table = (props) => {
  const navigate = useNavigate();
  const history = createBrowserHistory();
  const [ticketsTableData, setTicketsTableData] = useState([]);
  const [userTableData, setUserTableData] = useState([]);
  const [departmentoptions, setDepartmentOptions] = useState([]);
  const [rolesoptions, setRolesOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [roles, setRoles] = useState([]);
  const initialState = {
    mouseX: null,
    mouseY: null,
  };
  const [state, setState] = useState(initialState);
  const [id, setId] = useState("");
  const handleClick = (event) => {
    event.preventDefault();
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleClose = () => {
    setState(initialState);
  };
  useEffect(() => {
    const table = $("#dataTable").DataTable({
      order: [],
    });
  }, [$]);

  useEffect(async () => {
    Swal.showLoading();
    $("#dataTable").DataTable().destroy();
    if (props.config) {
      axios.get(`${BASE_URL}/tickets/getusers.php`).then((res) => {
        setEmployees(res.data.data.assignedepartment);
        setRoles(res.data.data.assignedroles);
        setUserTableData(res.data.data.users);
        props.data(res.data.data.users);
        const departmentOptions = res.data.data.departments?.map((element) => {
          return { value: element.id, label: `${element.department}` };
        });
        const rolesOptions = res.data.data.roles?.map((element) => {
          return { value: element.id, label: `${element.role}` };
        });

        setDepartmentOptions(departmentOptions);
        setRolesOptions(rolesOptions);
        $("#dataTable").DataTable({
          order: [],
        });
        Swal.close();
      });
    } else {
      if (props.departmentid === "") {
        const res = await axios
          .get(`${BASE_URL}/tickets/gettickets.php`)
          .then((res) => {
            setTicketsTableData(res.data.data);
            $("#dataTable").DataTable({
              order: [],
            });
            Swal.close();
          });
      } else {
        if (props.user?.role_id === "1") {
          const res = await axios
            .post(`${BASE_URL}/tickets/getticketsfordepartment.php`, {
              id: props.departmentid,
            })
            .then((res) => {
              setTicketsTableData(res.data.data.tickets);
              $("#dataTable").DataTable({
                order: [],
              });
              Swal.close();
            });
        } else {
          const res = await axios
            .post(`${BASE_URL}/tickets/getticketsfordepartment.php`, {
              id: props.departmentid,
            })
            .then((res) => {
              setTicketsTableData(res.data.data.tickets);
              $("#dataTable").DataTable({
                order: [],
              });
              Swal.close();
            });
        }
      }
    }
  }, [props.add]);
  const handleRoleChange = (selectedOptions, id) => {
    let users = [...userTableData];
    users?.map((user) => {
      if (user.id === id) {
        if (selectedOptions === null) {
          user.role_id = "";
        } else {
          user.role_id = selectedOptions.value;
        }
      }
    });
    setUserTableData([...users]);
    props.data([...users]);
  };
  const handleDepartmentChange = (selectedOptions, id) => {
    let users = [...userTableData];
    users?.map((user) => {
      if (user.id === id) {
        user.department_id = { ...selectedOptions };
      }
    });
    setUserTableData([...users]);
    props.data([...users]);
  };
  console.log(userTableData);
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: 250,
    }),
  };

  return (
    <>
      <div className="table-responsive-sm">
        <table id="dataTable" className="table table-striped table-sm">
          <thead>
            {props.config ? (
              <tr className="tr">
                <th className="th">ID</th>
                <th className="th">Name</th>
                <th className="th">Email</th>
                <th className="th">Job Title</th>
                <th className="th">Role</th>
                <th className="th">Department</th>
              </tr>
            ) : (
              <tr className="tr">
                <th className="th">ID</th>
                <th className="th">Ticket Owner</th>
                <th className="th">Ticket Owner Type</th>
                <th className="th">Subject</th>
                <th className="th">Date</th>
                <th className="th">Status</th>
                <th className="th">Department</th>
                <th className="th"> Actions</th>
              </tr>
            )}
          </thead>
          <tbody style={props.style}>
            {props.config && roles
              ? userTableData?.map((dt, index) => {
                  return (
                    <tr key={dt.id} className="tr" id={dt.id}>
                      <td className="td">{dt.id}</td>
                      <td className="td">{dt.displayname}</td>
                      <td className="td">{dt.username}</td>
                      <td className="td">{dt.jobtitle}</td>
                      <td className="td">
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          styles={customStyles}
                          defaultValue={roles[index]}
                          options={rolesoptions}
                          isClearable
                          onChange={(selectedOption) => {
                            handleRoleChange(selectedOption, dt.id);
                          }}
                        />
                      </td>
                      <td className="td">
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          styles={customStyles}
                          isMulti
                          isClearable
                          defaultValue={employees
                            ?.find((f) => f.id === dt.id)
                            ?.departments?.map((empdepartment) => {
                              return {
                                value: empdepartment.id,
                                label: empdepartment.department,
                              };
                            })}
                          onChange={(selectedOption) => {
                            handleDepartmentChange(selectedOption, dt.id);
                          }}
                          options={departmentoptions}
                          isDisabled
                        />
                      </td>
                    </tr>
                  );
                })
              : ticketsTableData?.map((dt) => {
                  if (
                    props.departmentid === "" &&
                    !(props.user?.role_id === "1")
                  ) {
                    return (
                      <tr key={dt.id} className="tr" id={dt.id}>
                        <td className="td">{dt.id}</td>
                        <td className="td">{dt.displayname}</td>
                        <td className="td">
                          {dt.username?.search("ivy") === -1
                            ? "Parent"
                            : "Employee"}
                        </td>
                        <td className="td">{dt.subject}</td>
                        <td className="td">{dt.date}</td>
                        <td className="td">{dt.status}</td>
                        <td className="td">{dt.department}</td>
                        <td className="td">
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              navigate(`/departmentticket/${dt.id}`);
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr key={dt.id} id={dt.id}>
                        <td>{dt.id}</td>
                        <td>{dt.displayname}</td>
                        <td>
                          {dt.username.search("ivy") === -1
                            ? "Parent"
                            : "Employee"}
                        </td>
                        <td>{dt.subject}</td>
                        <td>{dt.date}</td>
                        <td>{dt.status}</td>
                        <td className="td">{dt.department}</td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              navigate(`/departmentticket/${dt.id}`);
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    );
                  }
                })}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Table;
